export default __webpack_public_path__ + "static/media/jira-icon.5c6a6c10.svg";